import "@google/model-viewer";

const MyARViewer = () => {
  return (
    // eslint-disable-next-line react/react-in-jsx-scope
    <model-viewer
      src="s.glb"
      ar
      ar-modes="webxr scene-viewer quick-look"
      environment-image="neutral"
      auto-rotate
      camera-controls
      shadow-intensity="1"
      ar-scale="auto" // Автоматически масштабирует модель под размеры плоскости
      style={{ width: "100vw", height: "calc(100vh - 60px)" }}
    ></model-viewer>
  );
};

export default MyARViewer;
